import { lazy } from 'react';

const DocumentsPage = lazy(() => import('./pages/DocumentsPage'));
const DocumentTypePage = lazy(() => import('./pages/DocumentTypePage'));

export const DocumentsEntry = () => <DocumentsPage />;

export const DocumentTypeEntry = () => <DocumentTypePage />;
